/**
* @description 参与考勤管理人员-筛选
* @author daxiong
*/
<template>
  <div id="participants">
    <section class="top-if">
      <van-search
        v-model="condition.staffName"
        placeholder="搜索"
        input-align="center"
        @input="getEntEmployeeInfo()"
      />
      <div class="group-cub">
        <span class="group-name">{{ userInfo.entName }}</span>
      </div>
    </section>
    <!-- 全选 -->
    <section>
      <van-cell>
        <template #title>
          <van-checkbox v-model="radioAll" @click="radioAllClick"
            >全选</van-checkbox
          >
        </template>
      </van-cell>
    </section>
    <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
      <van-list
        v-model="isUpLoading"
        :finished="upFinished"
        @load="onLoad"
        :offset="offset"
        :finished-text="textBottom"
      >
        <!-- 考勤组 -->
        <section class="group-box">
          <van-checkbox-group
            v-model="checkedList"
            ref="checkboxGroup"
            @change="checkedListChange"
            class="group-arr"
          >
            <van-cell v-for="(item, index) in groupList" :key="index">
              <template #title>
                <van-checkbox :name="item.mobile">
                  <div class="img">
                    <van-icon name="user-circle-o" />
                  </div>
                  <div class="info">
                    <div class="name">{{ item.staffName }}</div>
                    <div class="entName">{{ item.postOffice }}</div>
                  </div>
                </van-checkbox>
              </template>
            </van-cell>
          </van-checkbox-group>
        </section>
      </van-list>
    </van-pull-refresh>

    <div class="confirm-box">
      <div class="checked-number" @click="showCheckedAll = true">
        已选择：{{ participantsList.length }}人 <van-icon name="arrow-up" />
      </div>
      <van-button type="info" size="small" @click="confirmCheckedIf"
        >确定({{ participantsList.length }}/{{
          noStaffNameList.length
        }})</van-button
      >
    </div>

    <van-popup
      v-model="showCheckedAll"
      class="checked-all-popup"
      position="bottom"
    >
      <div
        class="checked-personnel"
        v-for="(item, index) in participantsList"
        :key="index"
      >
        <div class="img">
          <van-icon name="user-circle-o" />
        </div>
        <div class="info">
          <div class="name">{{ item.staffName }}</div>
          <div class="entName">{{ item.entName }}</div>
        </div>
        <div class="det" @click="groupListDelete(item.mobile)">
          <van-icon name="close" />
        </div>
      </div>
      <div class="checked-confirm">
        <van-button type="info" class="confirm" @click="showCheckedAll = false"
          >确认</van-button
        >
      </div>
    </van-popup>
  </div>
</template>

<script>
import { addEmployee, queryAllEmployee } from "@api/lishui";
import { getLocalStorage } from "@utils";
export default {
  components: {},
  props: ["getType"],
  data() {
    return {
      userInfo: JSON.parse(getLocalStorage("lishuiUserInfo"))
        ? JSON.parse(getLocalStorage("lishuiUserInfo"))
        : {},
      radioAll: false, // 是否全选
      condition: {},
      checkedList: [], // 已选中的唯一标识集合
      // isShowChild: false, // 是否显示组内成员
      showCheckedAll: false, // 是否显示已选中的成员弹框
      groupName: "", // 组名
      noStaffNameList: [], // 全部参与人员集合
      participantsList: this.$store.state.clock.groupParticipants || [],
      groupList: [],
      phoneMobileList: [],
      isLoading: false, //下拉刷新
      isUpLoading: false, //上拉加载
      upFinished: false, //上拉加载完毕
      finished: false,
      offset: 100, //滚动条与底部距离小于 offset 时触发load事件
      pages: 0,
      textBottom: "", //底部内容文字
    };
  },
  computed: {},
  watch: {
    /**
     * @description 同步到已选中
     */
    checkedList: {
      deep: true,
      handler(val) {},
    },
  },
  methods: {
    // 下拉调用此函数
    onRefresh() {
      setTimeout(() => {
        // this.$toast("刷新成功"); //弹出
        this.isLoading = false;
      }, 500);
    },
    // 上拉调用此函数
    onLoad() {
      setTimeout(() => {
        this.isUpLoading = false;
        this.getEntEmployeeInfo();
      }, 500);
    },
    radioAllClick() {
      this.$refs.checkboxGroup.toggleAll(this.radioAll);
    },

    /**
     * @description 删除已选中的参与人员
     * @param {string} mobile 唯一标识
     */
    groupListDelete(mobile) {
      let index = this.checkedList.findIndex((v) => {
        return v === mobile;
      });
      // debugger
      this.checkedList = [
        ...this.checkedList.slice(0, index),
        ...this.checkedList.slice(index + 1),
      ];
    },

    checkedListChange(val) {
      this.phoneMobileList = val;
      if (val.length !== this.groupList.length) {
        this.radioAll = false;
      }
      this.participantsList = [];
      this.noStaffNameList.map((v) => {
        if (val.includes(v.mobile)) {
          this.participantsList.push(v);
        }
      });
    },

    /**
     * @description 添加管理人员
     */
    selectAllStaff() {
      let params = {
        creditCode: this.userInfo.creditCode,
        mobileList: this.phoneMobileList.toString(),
        // staffName: this.condition.staffName,
        // belongId: window.location.href.includes("/groupEditor?id=")
        //   ? this.$route.query.id
        //   : "",
      };
      addEmployee(params).then((response) => {
        let res = response.data;
        if (res.code == "0000") {
          setTimeout(() => {
            this.$notify({
              type: "success",
              message: res.msg,
            });
          }, 800);
        } else {
          this.$notify({
            type: "success",
            message: res.msg,
          });
        }
      });
    },

    /**
     * @description 查询全部员工
     */
    getEntEmployeeInfo(e) {
      if (e === 1) {
        this.noStaffNameList = [];
        this.participantsList = [];
      }
      this.pages++;
      queryAllEmployee({
        pageNum: this.pages,
        pageSize: 10,
        creditCode: this.userInfo.creditCode,
        staffName: this.condition.staffName,
      }).then((response) => {
        let res = response.data;
        if (res.code == "0000") {
          let lists = res.data.results || [];
          if (lists.length === 0) {
            this.upFinished = true;
          } else {
            this.upFinished = false;
          }
          for (var i = 0; i < lists.length; i++) {
            this.groupList.push(lists[i]); // 上拉时循环出来这个数组的三条内容，放入datacontent这个数组里，那样就一直拉一直加
            if (!this.condition.staffName) {
              this.noStaffNameList.push(lists[i]);
              // this.noStaffNameList.map(v => {
              //     if(this.checkedList.includes(v.mobile)) {
              //         this.participantsList.push(v)
              //     }
              // })
            }
          }

          if (this.groupList.length > 7) {
            this.textBottom = "我也是有底线的~~~";
          }
          //   this.groupList = res.data.results || [];

          if (window.location.href.includes("/groupEditor?id=")) {
            this.checkedList = this.participantsList.map((v) => v.mobile);
          }
          if (this.checkedList.length !== this.groupList.length) {
            this.radioAll = false;
          }
        } else {
          this.$notify({
            type: "success",
            message: res.msg,
          });
        }
      });
    },

    /**
     * @description 显示组内成员
     */
    showChild(item) {
      this.isShowChild = true;
      this.groupName = item.groupName;
    },

    /**
     * @description 确认参与人员
     */
    confirmCheckedIf() {
      this.$store.commit("clock/setGroupParticipants", this.participantsList);
      this.$emit("closePopupByParticipants", this.participantsList);
      if (this.phoneMobileList.length > 0) {
        this.selectAllStaff();
        this.pages = 0;
        this.groupList = [];
        this.participantsList = [];
        this.getEntEmployeeInfo(1);
      }
    },

    getList() {
      //   if (this.getType == "all") {
      //     this.getEntEmployeeInfo();
      //   } else {
      //     this.selectAllStaff();
      //   }
    },
  },
  created() {
    // this.getList();
    this.getEntEmployeeInfo(1);
  },
  mounted() {},
};
</script>
<style lang='scss' scoped>
#participants {
  height: 100vh;
  font-size: 14px;
  section {
    margin-bottom: 8px;
    &.group-box {
    }
    &.top-if {
      background: #fff;
      padding-bottom: 10px;
      .group-cub {
        display: flex;
        align-items: center;
        margin-left: 20px;
        color: #999;
        i {
          margin: 0 5px;
        }
        .group-name {
          &.active {
            color: #0091ff;
          }
        }
      }
    }
  }
  .group-arr {
    box-sizing: border-box;
    height: calc(100vh - 182px);
    padding-bottom: 40px;
    overflow-y: auto;
  }
  ::v-deep .van-cell {
    .van-radio__icon,
    .van-checkbox__icon {
      width: 16px;
      height: 16px;
      font-size: 16px;
    }
    &__title {
      display: flex;
      align-content: center !important;
      justify-content: space-between !important;

      .r-down {
        color: #0091ff;
        padding-left: 10px;
        border-left: 1px solid rgba(0, 0, 0, 0.05);
      }

      .van-checkbox__label {
        display: flex;
        align-items: center;

        .img {
          width: 42px;
          height: 42px;
          background: #0091ff;
          border-radius: 50%;
          margin-right: 10px;
          color: #fff;
          display: flex;
          justify-content: center;
          align-items: center;
          i {
            font-size: 62px;
          }
        }

        .info {
          .name {
            color: #333;
            margin-right: 9px;
            font-size: 16px;
            span {
              font-size: 12px;
              color: #0091ff;
              background: #b3deff;
              border: 1px solid #e9f5ff;
              border-radius: 4px;
              padding: 2px;
              margin-left: 5px;
            }
          }
          .entName {
            margin-top: 5px;
            font-size: 12px;
            color: #666;
          }
        }
      }
    }
  }

  ::v-deep .van-search__content {
    border-radius: 17px;
  }

  .confirm-box {
    box-sizing: border-box;
    width: 100%;
    height: 75px;
    background: #fff;
    box-shadow: 0 0 10px 1px rgba(0, 0, 0, 0.05);
    position: fixed;
    bottom: 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 10px;
    .checked-number {
      color: #0091ff;
      display: flex;
      align-items: center;
      i {
        margin-left: 5px;
      }
    }
  }

  ::v-deep .checked-all-popup {
    width: 100vw;
    height: 100vh;
    background: #f7f7f7;
    .checked-personnel {
      height: 70px;
      background: #fff;
      display: flex;
      align-items: center;
      padding: 0 20px;
      position: relative;

      .det {
        position: absolute;
        right: 20px;
        top: 50%;
        transform: translateY(-50%);
        font-size: 24px;
        color: #999;
      }

      .img {
        width: 42px;
        height: 42px;
        background: #0091ff;
        border-radius: 50%;
        margin-right: 10px;
        color: #fff;
        display: flex;
        justify-content: center;
        align-items: center;
        i {
          font-size: 62px;
        }
      }

      .info {
        .name {
          color: #333;
          margin-right: 9px;
          font-size: 16px;
          span {
            font-size: 12px;
            color: #0091ff;
            background: #b3deff;
            border: 1px solid #e9f5ff;
            border-radius: 4px;
            padding: 2px;
            margin-left: 5px;
          }
        }
        .entName {
          margin-top: 5px;
          font-size: 12px;
          color: #666;
        }
      }
    }
    .checked-confirm {
      box-sizing: border-box;
      width: 100%;
      height: 75px;
      background: #fff;
      box-shadow: 0 0 10px 1px rgba(0, 0, 0, 0.05);
      position: fixed;
      bottom: 0;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 10px;
      .confirm {
        width: 100%;
        height: 40px;
      }
    }
  }
}
</style>